import { PropsWithChildren, useMemo } from 'react'
import { SWRConfig } from 'swr'

import { useAuthStore } from '@/store/auth'
import { redirectToLoginOnSessionExpired } from '@/utils/session-error'

import { useAuth } from '@/api/auth'
import { createFetcher } from '@/lib/swr/fetcher'

function SWRProvider({ children }: PropsWithChildren) {
  const getAccessToken = useAuthStore((state) => state.getAccessToken)
  const { refreshTokenWithLock } = useAuth()
  const fetcher = useMemo(
    () => createFetcher(getAccessToken, {}, refreshTokenWithLock, redirectToLoginOnSessionExpired),
    [getAccessToken, refreshTokenWithLock]
  )

  return (
    <SWRConfig
      value={{
        fetcher,
        revalidateOnFocus: false,
        shouldRetryOnError: false,
        dedupingInterval: 2000
      }}
    >
      {children}
    </SWRConfig>
  )
}

export default SWRProvider
